import { render, staticRenderFns } from "./comp_BookEditorCustomizationInputs-name-gender-lang-inscription.vue?vue&type=template&id=a5eacb5a&"
import script from "./comp_BookEditorCustomizationInputs-name-gender-lang-inscription.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorCustomizationInputs-name-gender-lang-inscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports